module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ml10"
  }, _vm._l((_vm.data.linesData), function(linesData) {
    return _c('div', _vm._l((linesData), function(lines) {
      return _c('div', [_c('p', {
        staticClass: "bold",
        domProps: {
          "innerHTML": _vm._s(_vm.changeTag(lines.text))
        }
      }), _vm._v(" "), _vm._l((lines.lineChildren), function(child) {
        return _c('div', {
          staticClass: "mb10"
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(_vm.changeTag(child.childText))
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "ml20",
          domProps: {
            "innerHTML": _vm._s(_vm.changeTag(child.examples.example))
          }
        })])
      })], 2)
    }), 0)
  }), 0)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50605392", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-50605392","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dictionary/SetPhraseResult.vue
// module id = 719
// module chunks = 1